import { useTranslation } from 'react-i18next';
import { HighlighterIcon } from 'lucide-react';
import { CommentAnchorChip } from '@/entities/project-comment';

interface Props {
  /** Drops the anchor; pass the anchor's own cancel so the editor's draft highlight goes too. */
  onClear?: () => void;
}

/** The text-range case of the composer's anchor chip, in the warning tone it has always had. */
export function HighlightCommentComposerChip({ onClear }: Props) {
  const { t } = useTranslation('projects');

  return (
    <CommentAnchorChip
      tone="warning"
      testId="comment-highlight-composer-chip"
      icon={<HighlighterIcon className="size-3 shrink-0" />}
      label={t('commentOnFile.highlightCommentComposerChip.highlight')}
      ariaLabel={t('commentOnFile.highlightCommentComposerChip.commentWillBeAnchoredTo')}
      onClear={onClear}
      clearLabel={t('commentOnFile.highlightCommentComposerChip.removeHighlight')}
    />
  );
}
